import { formatTimestampInTimezone } from 'utils/time';
import { Typography } from '@mui/material';
import React, { useMemo } from 'react';
import classNames from 'classnames';

import styles from './TimeCell.module.scss';

type Props = {
  loading?: boolean;
  isMobile: boolean;
  timestamp: number | null;
  utcOffset: number | null;
};

const TimeCell: React.FC<Props> = ({ timestamp, isMobile, loading, utcOffset }) => {
  const error = !timestamp;
  const loadingOrError = loading || error;
  const timeVariant = isMobile ? 'caption2' : 'overline2';
  const formattedHour = useMemo(() => {
    const time = formatTimestampInTimezone(timestamp || 0, utcOffset || 0, 'haaa');

    if (time === '12pm') return 'Noon';
    return time;
  }, [timestamp, utcOffset]);

  const text = useMemo(
    () => (loadingOrError ? '12am' : formattedHour),
    [formattedHour, loadingOrError],
  );

  const textColor = useMemo(
    () => (loadingOrError ? 'text.light' : 'text.secondary'),
    [loadingOrError],
  );

  return (
    <div
      data-testid="forecast-table-time-cell"
      className={classNames({
        [styles.wrapper]: true,
        [styles.withObserved]: true,
      })}
    >
      <Typography
        className={styles.time}
        color={textColor}
        data-testid="forecast-table-time"
        variant={timeVariant}
      >
        {text}
      </Typography>
    </div>
  );
};

export default TimeCell;
